import { ReactNode } from 'react';

import { ElementComponent, TranslateOptions } from './types';

const PARTS_REGEXP = /(?:\{#([\w]+)\}(.*?)\{\/\1\}|\{#([\w]+)\/\})/g;

const parseMessage = (
  message: string = '',
  elements: TranslateOptions['elements'] = {},
): ReactNode[] | null => {
  const elementParts: {
    Element: ElementComponent;
    children: string;
  }[] = [];

  const textParts = message
    .replace(
      PARTS_REGEXP,
      (source, elementKey, children = null, singleElementKey) => {
        const key = elementKey || singleElementKey;
        const Element = elements[key];

        if (!Element) {
          return source;
        }

        elementParts.push({
          Element,
          children: children && parseMessage(children, elements), // handle possible inner elements
        });

        return `{#${key}_${elementParts.length}/}`;
      },
    )
    .split(/\{#[^#}]+?\/\}/);

  const allChildren: ReactNode[] = [];

  textParts.forEach((textPart) => {
    if (textPart) {
      allChildren.push(textPart);
    }
    const elementData = elementParts.shift();

    if (elementData) {
      const { Element, children } = elementData;

      allChildren.push(<Element key={elementParts.length}>{children}</Element>);
    }
  });

  return allChildren;
};

export default parseMessage;
